import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';

import { LoadingState } from '~libs/reduxUtils';

import { getAll, getOne, typePrefix } from '~care-workers/actions/userPayLevels';

interface UserPayLevelRow {
  id: number;
  name?: string;
}

interface UserPayLevelsState {
  loading: LoadingState;
  error: string | null | undefined;
  rows: Array<UserPayLevelRow>;
  row?: UserPayLevelRow;
}

const initialState: UserPayLevelsState = {
  loading: 'idle',
  error: null,
  rows: [],
};

// Main slice, connecting API actions to redux state.
export const userPayLevelsSlice = createSlice({
  name: 'user-pay-levels',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAll.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.rows = action.payload.data;
    });
    builder.addCase(getOne.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.row = action.payload.data;
    });
    // Default matching for loading cases, pending when action is being called
    builder.addMatcher(isPending, (state, { type }) => {
      if (type.startsWith(`${typePrefix}/`)) state.loading = 'pending';
    });
    builder.addMatcher(isRejected, (state, action) => {
      if (action.type.startsWith(`${typePrefix}/`)) {
        state.loading = 'declined';
        state.error = action.error.message;
      }
    });
  },
});

export default userPayLevelsSlice.reducer;
